import {
  DataWarehouseObjectType,
  DbtObjectType,
  DbtObjectTypes,
  QueryPageWarehouse,
} from '@dbt-labs/integrations/productHandoffs/productHandoffURIs';

import { WarehouseEntityType } from '@/__generated__/graphql';
import { NavigationResourceType } from '@/panel/ResourcesFilter/selectedResource';

export type CanvasHandoff = 'create' | 'edit';

const canvasCreateResourceTypes = ['model'] as const;
const canvasEditResourceTypes = ['model'] as const;

export type CanvasCreateResourceType = (typeof canvasCreateResourceTypes)[number];
export type CanvasEditResourceType = (typeof canvasEditResourceTypes)[number];

export type CanvasHandoffResourceTypes =
  | CanvasCreateResourceType
  | CanvasEditResourceType;

export const isResourceSupported = (
  handoff: CanvasHandoff,
  resourceType: NavigationResourceType | 'package',
): boolean => {
  if (handoff === 'create')
    return canvasCreateResourceTypes.includes(resourceType as CanvasCreateResourceType);
  return canvasEditResourceTypes.includes(resourceType as CanvasEditResourceType);
};

export const resourceTypeToDbtObjectType: Record<
  CanvasHandoffResourceTypes,
  DbtObjectType
> = {
  model: DbtObjectTypes.MODEL,
};

export type HandoffDWHObjectTypes =
  | WarehouseEntityType.Table
  | WarehouseEntityType.View;

export const resourceTypeToDWHHandoffType: Record<
  HandoffDWHObjectTypes,
  DataWarehouseObjectType
> = {
  [WarehouseEntityType.Table]: 'dwh_table',
  [WarehouseEntityType.View]: 'dwh_view',
};

export const supportedDWHResourceTypes = [
  WarehouseEntityType.Table,
  WarehouseEntityType.View,
];

export type CanvasDataWarehouseObject = {
  type: HandoffDWHObjectTypes;
  id: string;
  warehouseType: QueryPageWarehouse;
};
